/**
 * @function axboot.uploaderBuilder
 * @param {Object} _config
 */
axboot.uploaderBuilder = function () {
    var defaultUploadConfig = {
        //debug: true,
        form: {
            action: axboot.def.uploader.uploadUrl,
            fileName: 'file'
        },
        viewMode: false,
        multiple: true,
        manualUpload: false,
        progressBox: true,
        progressBoxDirection: 'left',
        onprogress: function () {
            //console.log('##### onprogress');
        },
        onuploaderror: function () {
            //console.log('##### onuploaderror');

            axboot.util.responseResultMsg(this.error);
        },
        onuploaded: function (data) {
            var responseType = axboot.util.getResponseType(data);

            if (responseType == 'validation' && data.errorCount > 0) {
                axboot.util.responseResultMsg(data);
            } else {
                if (ax5.util.isNothing(this.self.getAttachId())) {
                    // 업로드 아이디와 같은 입력 상자에 첨부 아이디를 설정한다.
                    this.self.setAttachId(data['attachId']);
                }

                this.self.isBeforeUploaded = true;
            }
        },
        onuploadComplete: function () {
            var that = this;

            this.self.loadUploaded(function () {
            	that.self.isType = "upload";
                __onComplete(that.self);

                that.self.isBeforeUploaded = false;
            });
        }
    }

    var __downloadFile = function (downloadUrl) {
        if (!ax5.util.isNothing(downloadUrl)) {
            axboot.file.download(downloadUrl);
        }
    }

    var __deleteFile = function (uploader, fileIndex, file, grid) {
        var mask = new ax5.ui.mask();

        axDialog.confirm({
            theme : 'danger',
            title : '삭제확인',
            msg   : '선택한 파일을 삭제하시겠습니까?',
            onStateChanged: function () {
                if (this.state === 'open') {
                    mask.open({theme: 'danger'});
                }
                else if (this.state === 'close') {
                    mask.close();
                }
            }
        }, function () {
            if (this.key == 'ok') {
                var objectType = axboot.util.getObjectType(uploader);

                if (grid != null) {
                    objectType = axboot.util.getObjectType(grid);
                }

                axboot.command.ajax(axboot.def.uploader.deleteUrl, [{ 'storageId' : file.storageId, 'attachId': file.attachId, 'fileSn': file.fileSn }], function (data) {
                    if (data.error) {
                        alert(data.error.message);
                        return;
                    }

                    uploader.loadUploaded(function () {
                    	uploader.isType = "delete";
                        __onComplete(uploader);
                    });
                });
            }
        });
    }

    var __onComplete = function (uploader) {
        if (uploader.config.hasOwnProperty('onComplete') && ax5.util.getType(uploader.config.onComplete) === 'function') {
            uploader.config.onComplete.call(uploader, {
                'attachId'  : uploader.getAttachId(),
                'fileCount' : uploader.uploadedFiles.length,
                'isBeforeUploaded' : uploader.isBeforeUploaded,
                'isType' : uploader.isType 
            });
        }
    }

    return function (_config) {
        var limitCount = 1;
        var limitCapacity = 0;

        var myUploaderConfig = $.extend(true, {}, defaultUploadConfig, _config);

        var $target         = myUploaderConfig.target;
        var targetId        = $target.attr('id');
        var storageId       = $target.find('input[name=storageId]').val();
        var isUploadedBox   = $target.data('isUploadedBox');
        var isDropZone      = $target.data('isDropZone');
        var isViewMode      = $target.data('isViewMode');
        var uploadedBoxType = $target.data('uploadedBoxType');

        // 저장소 정보 설정
        if (!ax5.util.isNothing(storageId)) {
            axboot.command.ajax(axboot.def.uploader.storageUrl, { 'storageId' : storageId }, function (res) {
                limitCount = res['limitCount'];
                limitCapacity = res['limitCapacity'];

                $target.find('[data-file-limit-count]').text(limitCount);
                $target.find('[data-file-limit-capacity]').text(limitCapacity);
            });
        }

        $target.find('[data-file-capacity]').text(ax5.util.number(0, { 'byte' : true }));

        // 업로드 제한 개수 설정
        if (myUploaderConfig.hasOwnProperty('limitCount')) {
            limitCount = myUploaderConfig['limitCount'];
        }

        // 파일 업로드 검증 추가
        if (!myUploaderConfig.hasOwnProperty('validateSelectedFiles')) {
            myUploaderConfig.validateSelectedFiles = function () {
                this.self.isBeforeUploaded = false;

                if (this.uploadedFiles.length + this.selectedFiles.length > limitCount) {
                    axDialog.alert('파일 업로드 제한개수는 ' + limitCount + '개 입니다.');
                    return false;
                }

                return true;
            }
        }

        // 파일 드래그 앤 드롭 지원
        if (!myUploaderConfig.hasOwnProperty('dropZone') && isDropZone) {
            myUploaderConfig['dropZone'] = {
                target: $('[data-uploaded-box="' + targetId + '"]')
            }
        }

        // 업로드 박스 표시
        if (isUploadedBox && uploadedBoxType.toUpperCase() === 'DEFAULT' && !myUploaderConfig.hasOwnProperty('uploadedBox')) {
            myUploaderConfig['uploadedBox'] = {
                target: $('[data-uploaded-box="' + targetId + '"]'),
                icon: {
                    'download': '<i class="fa fa-download" aria-hidden="true"></i>',
                    'delete': '<i class="fa fa-minus-circle" aria-hidden="true"></i>'
                },
                columnKeys: {
                    name: 'fileName',
                    type: 'ext',
                    size: 'fileSize',
                    uploadedName: 'saveName',
                    uploadedPath: '',
                    downloadPath: '',
                    previewPath: '',
                    thumbnail: ''
                },
                lang: {
                    supportedHTML5_emptyListMsg: '<div class="text-center" style="padding-top: 30px;">Drop files here or click to upload.</div>',
                    emptyListMsg: '<div class="text-center" style="padding-top: 30px;">Empty of List.</div>'
                },
                onchange: function () {

                },
                onclick: function () {
                    var that = this;
                    var fileIndex = this.fileIndex;
                    var file = this.uploadedFiles[fileIndex];

                    switch (this.cellType) {
                        case 'delete':
                            __deleteFile(that.self, fileIndex, file);
                            break;
                        case 'download':
                            __downloadFile(file.download);
                            break;
                    }
                }
            }
        }

        var uploader = new ax5.ui.uploader(myUploaderConfig);
        uploader['uploadedGridBox'] = undefined;
        uploader['isBeforeUploaded'] = false;

        // 업로드 박스 타입이 그리드일 경우
        if (isUploadedBox && uploadedBoxType.toUpperCase() === 'GRID') {
            var uploadedGridBox = new ax5.ui.grid({
                target: $('[data-ax5grid="' + targetId + '"]'),
                columns: [
                    { key: 'fileName', label: '파일명', width: 250, sortable: true },
                    { key: 'fileSize', label: '파일크기', width: 70, align: 'right', sortable: true,
                        formatter: function () {
                            return ax5.util.number(this.value, { 'byte' : true});
                        }
                    },
                    { key: 'ext', label: '확장자', align: 'center', width: 70, sortable: true },
                    { key: 'createdAt', label: '등록일', align: 'center', width: 140, sortable: true,
                        formatter: function () {
                            return this.value != null ? moment(this.value).format(axboot.def.dateTimeFormat) : '';
                        }
                    },
                    { key: 'download', label: '다운로드', width: 65, align: 'center',
                        formatter: function () {
                            return '<i class="fa fa-download" style="cursor: pointer" aria-hidden="true"></i>'
                        }
                    },
                    { key: 'delete', label: '삭제', width: 50, align: 'center',
                        formatter: function () {
                            return '<i class="fa fa-minus-circle" style="cursor: pointer" aria-hidden="true"></i>'
                        }
                    }
                ],
                body: {
                    onClick: function () {
                        this.self.select(this.dindex, { selectedClear: true });

                        if (this.column.key == 'download' && this.item.download) {
                            __downloadFile(this.item.download);
                        } else if (this.column.key == 'delete') {
                            __deleteFile(uploader, this.dindex, this.item, this.self);
                        }
                    }
                },
                page: {
                    display: false
                }
            });

            // 삭제 컬럼 제거
            if (isViewMode) {
                uploadedGridBox.removeColumn(5);
            }

            uploader['uploadedGridBox'] = uploadedGridBox;
        }

        uploader['getStorageId'] = function () {
            var $storageInputBox = this.$target.find('input[name="storageId"]');

            return $storageInputBox.val();
        }

        uploader['getAttachId'] = function () {
            var targetId = this.$target.attr('id');
            var $attachInputBox = this.$target.find('input[name="' + targetId + '"]');

            return $attachInputBox.val();
        }

        uploader['setAttachId'] = function (attachId) {
            var targetId = this.$target.attr('id');
            var $attachInputBox = this.$target.find('input[name="' + targetId + '"]');

            $attachInputBox.val(attachId);

            $attachInputBox = this.$target.find('input[name="attachId"]');
            $attachInputBox.val(attachId);
        }

        uploader['setParams'] = function (params) {
            var targetId = this.$target.attr('id');
            var $paramsInputBox = this.$target.find('input[name="params"]');
            var paramsStr = '';

            if (ax5.util.getType(params) === 'object') {
                paramsStr = JSON.stringify(params);
            }

            $paramsInputBox.val(paramsStr);
        }

        // 파일 업로드 정보 표시
        uploader['loadUploaded'] = function (callback) {
            this.clear();

            if (!ax5.util.isNothing(this.getAttachId())) {
                var that = this;

                axboot.command.ajax(axboot.def.uploader.fileListUrl, { 'storageId' : this.getStorageId(), 'attachId' : this.getAttachId() }, function (data) {
                    that.setUploadedFiles(data);

                    var totalSize = 0;

                    for (var i = 0; i < data.length; i++) {
                        totalSize += data[i]['fileSize'];
                    }

                    that.$target.find('[data-file-capacity]').text(ax5.util.number(totalSize, { 'byte': true}));
                    that.$target.find('[data-file-count]').text(data.length);

                    if (that.hasOwnProperty('uploadedGridBox') && !ax5.util.isNothing(that.uploadedGridBox)) {
                        that.uploadedGridBox.setData(that.uploadedFiles);
                    }

                    if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                        callback.call(that);
                    }
                });
            } else {
                this.$target.find('[data-file-capacity]').text(ax5.util.number(0, { 'byte': true}));
                this.$target.find('[data-file-count]').text(0);

                if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                    callback.call(that);
                }
            }
        };

        return uploader;
    }
}();